import { render, staticRenderFns } from "./BenestareDetail.vue?vue&type=template&id=c6996a1a&"
import script from "./BenestareDetail.vue?vue&type=script&lang=js&"
export * from "./BenestareDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports